import React from 'react'
import clsx from 'clsx'

interface CardProps {
  children: React.ReactNode
  className?: string
  title?: string
  subtitle?: string
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

// Default p-6 only when the caller sets no padding of its own: Tailwind orders p-0 before p-6,
// so passing both would silently keep p-6.
const hasOwnPadding = (className?: string) => /(^|\s)p[xy]?-\d/.test(className || '')

export const Card: React.FC<CardProps> = ({ children, className, title, subtitle, onClick }) => (
  <div className={clsx('bp-shell-card', !hasOwnPadding(className) && 'p-6', className)} onClick={onClick}>
    {title && <h3 className="mb-1 text-base font-semibold text-slate-900">{title}</h3>}
    {subtitle && <p className="mb-4 text-sm text-slate-500">{subtitle}</p>}
    {children}
  </div>
)

export const CardGrid: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
    {children}
  </div>
)
